// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"proveInizialiTipo_moduleWrapper__KVkvM","documentRow":"proveInizialiTipo_documentRow__JcLOl","documentRow_marmi":"proveInizialiTipo_documentRow_marmi__1niHR"};